import * as yup from 'yup';

export const storeSchema = yup.object().shape({
  searchStore: yup.string().optional(),
  group: yup.string().optional(),
});
